import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
/*root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);*/

const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;
if(isMobile){
    document.body.style.backgroundColor = "black";
    root.render(
        <div style={{
            color: "white",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
        }}>
            <h2>
                Sorry, but this page is only available as a Desktop version!
            </h2>
        </div>
    );
}else{
    root.render(
        <App />
    );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
